// extracted by mini-css-extract-plugin
module.exports = {"cardButtonContainer":"acceptatie-card_cardButtonContainer__25kwh","btn":"acceptatie-card_btn__3RuUg","cardContainer":"acceptatie-card_cardContainer__VXSMn"};